// extracted by mini-css-extract-plugin
module.exports = {"enrollment":"ScholarshipFreeTransversalCompetences_enrollment__3Ga1r","titleError":"ScholarshipFreeTransversalCompetences_titleError__39Y3x"};